import React from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { getPageName } from '../../utils/helpers';
import { SEGMENT_EVENTS, trackEvent } from '../../utils/Segment';
import Button from '../../ui-core/Button/Button';
import { MODAL_TYPE } from '../../constants/app';
import PropTypes from 'prop-types';
import EmailEnvelopIcon from '../../static/images/email-envelope.svg';

const EmailLogin = ({ isLoading, section, handleModalState }) => {
  const history = useHistory();
  const page = getPageName(history.location.pathname);

  trackEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
    page: page,
    section_title: section,
    button_title: 'Sign up with Gmail',
  });

  const handleRedirection = () => handleModalState(MODAL_TYPE.EMAIL_LOGIN);

  return (
    <>
      <Button
        text={
          <div className="d-flex justify-content-center align-items-center">
            <img
              src={EmailEnvelopIcon}
              className="img-fluid mx-2"
              alt="Email Icon"
            />
            <span className="social_text">EMAIL</span>
          </div>
        }
        class="sign-with-button"
        isDisabled={isLoading}
        isLoading={isLoading}
        onClick={handleRedirection}
      ></Button>
    </>
  );
};

EmailLogin.propTypes = {
  isLoading: PropTypes.bool,
  section: PropTypes.string,
  handleModalState: PropTypes.func,
};

export default EmailLogin;
